import { FC, memo } from "react";
import { Typography, TypographyProps } from "@mui/material";
import { Help } from "components/Help";
import styles from "./styles";

type Props = TypographyProps & {
  text: string;
  help?: string;
};

const Label: FC<Props> = ({ variant = "h5", text, help, ...rest }) => (
  <Typography component="label" variant={variant} sx={styles.label} {...rest} className="RlxLabel">
    {text} {help && <Help text={help} />}
  </Typography>
);

Label.displayName = "Label";

export default memo(Label);
